module.exports = __webpack_public_path__ + "media/images/icon__settings@2x-9545e8293724d566e507fddcd6b3eff0.png";